module.exports = __webpack_public_path__ + "img/browser-grey.9f6adcf9.svg";